import { render, staticRenderFns } from "./HistoryProcess.vue?vue&type=template&id=7f666794&scoped=true&"
import script from "./historyProcess.ts?vue&type=script&lang=ts&"
export * from "./historyProcess.ts?vue&type=script&lang=ts&"
import style0 from "./HistoryProcess.vue?vue&type=style&index=0&id=7f666794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f666794",
  null
  
)

export default component.exports